/**
 * @fileoverview GET handler for the "/engagement/link_aliases/get_tracked_links" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementLinkAliasesGetTrackedLinks } from "./constants";
import type { GetTrackedLinksResult } from "./types";

export const getTrackedLinks = reactQueryFetcherAdapter(
  engagementLinkAliasesGetTrackedLinks,
  (signal: AbortSignal): Promise<GetTrackedLinksResult> => {
    return fetch("/engagement/link_aliases/get_tracked_links", "GET", {}, { signal });
  }
);
